import StatisticsRow from '../StatisticsRow';
import FootballGoalRowImage from './FootballGoalRowImage';
import TeamGoalsJerseyColumn from './TeamGoalsJerseyColumn';

interface RowTeamGoalsWithJerseysProps {
  /** Additional CSS classes to apply to the row container. */
  className?: string;
  /** Optional CSS classes to apply to the number elements. */
  numberColumnClassName?: string;
  /** Home team goal count. */
  homeNumber: number;
  /** Away team goal count. */
  awayNumber: number;
  /** Home team jersey image URL (left). */
  homeJerseySrc: string;
  /** Away team jersey image URL (right). */
  awayJerseySrc: string;
}

export default function RowTeamGoalsWithJerseys({
  className = '',
  homeNumber,
  awayNumber,
  homeJerseySrc,
  awayJerseySrc,
}: RowTeamGoalsWithJerseysProps) {
  return (
    <StatisticsRow className={`gap-3 px-0 ${className ?? ''}`}>
      <TeamGoalsJerseyColumn jerseySrc={homeJerseySrc} isAway={false} goalCount={homeNumber} />

      <div className="relative flex h-[72px] min-h-[72px] min-w-[96px] w-full flex-1 shrink items-center justify-center">
        <FootballGoalRowImage />
      </div>

      <TeamGoalsJerseyColumn jerseySrc={awayJerseySrc} isAway goalCount={awayNumber} />
    </StatisticsRow>
  );
}
